import { toProxy } from "@fanfanlo";
import { IMatrixRoomInfo, IMatrixRoomData, RoomMembership, IRoomMember, IBooleanState } from "./types";
import { IMatrixMessage } from "../message/types";
import { Log } from "@fanfanlo";

const fileLogger = new Log(false, 'im.client.room.data')
fileLogger.childrenPaused = true;
fileLogger.pause = true;

// 存储已加入房间的ID
const joinedRoomIds = new Set<string>();

// 初始化数据
const joinedRooms = toProxy<IMatrixRoomInfo[]>([]);
const messages = toProxy<Record<string, string[]>>({});
const messagesMap = toProxy<Record<string, IMatrixMessage>>({});
const roomMembers = toProxy<Record<string, Array<IRoomMember>>>({});
const isFetchingMembers = toProxy<IBooleanState>({ value: false });

// 房间数据对象
export const roomData = {
  joinedRooms,
  messages,
  messagesMap,
  roomMembers,
  isFetchingMembers,
  joinedRoomIds
};
